/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {UserDetailsModel} from "../../models/user-details-model";


export interface UserGetParams {
    accountGuid?: string;
    userGuid?: string;
}

export function userGet(http: HttpClient, rootUrl: string, params: UserGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsModel>> {
    const rb = new RequestBuilder(rootUrl, userGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params) {
        if (params.accountGuid) {
            rb.query('accountGuid', params.accountGuid);
        }
        rb.path('userGuid', params.userGuid, {"style":"simple"});
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<UserDetailsModel>;
        })
    );
}

userGet.PATH = '/api/v1/users/{userGuid}';
